export var EntityType;
(function (EntityType) {
    EntityType["COMPONENT"] = "component";
    EntityType["RISK"] = "risk";
    EntityType["MITIGATION"] = "mitigation";
    EntityType["SPACE"] = "space";
    EntityType["DIAGRAM"] = "diagram";
})(EntityType || (EntityType = {}));
